import { openModal } from '@/modalController';
import ModalWhitepaperDownload from './ModalWhitepaperDownload';

export default ModalWhitepaperDownload;
export { ModalWhitepaperDownload };

export function openModalWhitepaperDownload(props, options) {
  return openModal(ModalWhitepaperDownload, props, options);
}
